import Head from 'next/head'
import colors from '@ind-money/tailwind/tokens/colors'
import { WithChildren } from '@/root/types/utilities'

export const STRAPI_RICH_CONTENT_CONTAINER = 'strapi-rich-content-v4-ck-editor'

const blockquoteFontFamily = `Georgia, Helvetica, -apple-system, BlinkMacSystemFont, "Segoe UI",
Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif`

export const strapiRichTextStyles = `
  .${STRAPI_RICH_CONTENT_CONTAINER} {
    font-size: 1rem;
    color: ${colors.brand.black};
    font-family:'Inter';
  }

  @media screen and (min-width: 768px) {
    .${STRAPI_RICH_CONTENT_CONTAINER} {
      font-size: 1.125rem;
    }
  }

  .${STRAPI_RICH_CONTENT_CONTAINER} p {
    padding: 0.5rem 0;
    line-height: 1.625rem;
  }

  .${STRAPI_RICH_CONTENT_CONTAINER} blockquote {
    margin: 2rem 0;
    display: flex;
    align-items: baseline;
    font-style: italic;
    font-family: ${blockquoteFontFamily};
    font-size: 1.125rem;
    padding: 0 1rem;
  }

  .${STRAPI_RICH_CONTENT_CONTAINER} blockquote::after {
    content: no-close-quote;
  }

  .${STRAPI_RICH_CONTENT_CONTAINER} blockquote::before {
    color: #ccc;
    content: open-quote;
    font-size: 4rem;
    line-height: 0.1rem;
    margin-right: 0.1rem;
    vertical-align: -0.4rem;
    font-family: ${blockquoteFontFamily};
  }
  
  .${STRAPI_RICH_CONTENT_CONTAINER} table {
    table-layout: auto;
    margin: 2rem auto;
  }

  .${STRAPI_RICH_CONTENT_CONTAINER} td, .${STRAPI_RICH_CONTENT_CONTAINER} th {
    border: 1px solid ${colors.brand.grey.light};
    padding: 0.875rem;
  }

  .${STRAPI_RICH_CONTENT_CONTAINER} table tr:first-child {
    font-weight: 500;
  }

  .${STRAPI_RICH_CONTENT_CONTAINER} figure.table {
    margin: 0 auto;
    overflow: scroll;
    display: inherit;
  }

  .${STRAPI_RICH_CONTENT_CONTAINER} strong {
    fontWeight: 600;
  }

  .youtube-video-wrapper {
    width: 100%;
    position: relative;
    padding-top: 25px;
    padding-bottom: 56.25%;
    height: 0;
  }

  .youtube-video-wrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 16px;
  }

  .${STRAPI_RICH_CONTENT_CONTAINER} ol {
    list-style-type: decimal;
  }

  .${STRAPI_RICH_CONTENT_CONTAINER} ul {
    list-style-type: disc;
  }

  .${STRAPI_RICH_CONTENT_CONTAINER} ol, .${STRAPI_RICH_CONTENT_CONTAINER} ul {
    margin: 0.5rem 0;
    padding-left: 2.25rem;
    line-height: 1.875rem;
  }

  .${STRAPI_RICH_CONTENT_CONTAINER} li {
    margin: 0.375rem 0;
    line-height: 1.625rem;
  }

  .${STRAPI_RICH_CONTENT_CONTAINER} a {
    color: ${colors.brand.blue.azureRadiance};
  }

  .${STRAPI_RICH_CONTENT_CONTAINER} h1 {
    font-size: 2.125rem;
    margin: 0.5rem 0;
    font-weight: 500;
  }

  .${STRAPI_RICH_CONTENT_CONTAINER} h2 {
    font-size: 1.5rem;
    margin: 2.375rem 0 0.5rem 0;
    font-weight: 500;
  }

  .${STRAPI_RICH_CONTENT_CONTAINER} h3 {
    font-size: 1.125rem;
    margin: 0.5rem 0;
    font-weight: 500;
  }
`

const inlineStyleClass = 'strapi4-rich-text-editor-styles'

export function StrapiV4RichTextStyles({ children }: WithChildren) {
  return (
    <div className={STRAPI_RICH_CONTENT_CONTAINER}>
      <Head>
        <style
          dangerouslySetInnerHTML={{
            __html: strapiRichTextStyles,
          }}
          className={inlineStyleClass}
          key={inlineStyleClass}
        />
      </Head>

      {children}
    </div>
  )
}

export function StrapiV4RichTextEditor(props: TProps) {
  const {
    content,
    className = '[&>ul>li]:text-brand-grey-dark [&>p]:text-brand-grey-dark',
  } = props

  return (
    <StrapiV4RichTextStyles>
      <div
        dangerouslySetInnerHTML={{
          __html: content,
        }}
        className={className}
      />
    </StrapiV4RichTextStyles>
  )
}

type TProps = {
  content: string
  className?: string
}
